    <div>
        (Time: {{ minutes < 0 ?-(minutes):minutes }})
    </div>